module.exports = __webpack_public_path__ + "brandon_blk-webfont.c305e93b552586c29c37.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/brandon_blk-webfont.woff2
// module id = 936
// module chunks = 7